import React, { Component, PropTypes } from 'react';
import {
  StyledLeafDisclaimer
} from './styles'

class LeafDisclaimer extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
  };
  render() {
    const { className, text } = this.props;
    const divClass = `text-disclaimer ${className}`;
    return (
      <StyledLeafDisclaimer className={divClass}>
        <p>{text}</p>
      </StyledLeafDisclaimer>
    );
  }
}

export default LeafDisclaimer;



/** WEBPACK FOOTER **
 ** ./src/components/LeafDisclaimer/index.js
 **/